export const environment = {
  apiRoot: 'https://test-api.cms.southbound.dk/',
};
